export default __webpack_public_path__ + "static/media/con-pvr-legend.3b176d10.png";